import Feature from "src/js/stores/user/Feature";
import { userStore } from "src/js/stores/user/store";
import { useSnapshot } from "valtio";

export function useRegionAccess() {
  const { user } = useSnapshot(userStore);

  return {
    isUS: user.features.includes(Feature.usAccess),
  };
}
